<template>
  <div class="h-100">
    <div class="d-flex flex-column h-100">
      <v-row
        v-if="$vuetify.breakpoint.mobile"
        class="m-2"
      >
        <v-col
          cols="10"
          class="text-black"
        >
          {{ module.type != 'theme' ? module.subject.name : module.block.name }} : {{ module.name }}
        </v-col>
        <v-col>
          <i
            class="fa fa-times pointer-on-hover"
            @click="$emit('close')"
          />
        </v-col>
      </v-row>
      <v-card
        v-for="(current_content, current_key) in contents"
        :key="current_key"
        :class="{
          'border-nitro' : current_key === activeTab,
          'border-gray' : !current_content.started_at,
          'cursor-pointer bg-custom-light-blue' : current_content.finished_at,
        }"
        rounded="sm"
        class="my-2  border"
        :disabled="!current_content.finished_at && current_key != activeTab"
        @click="onClick(current_key, current_content)"
      >
        <v-card-text class="d-flex align-items-center py-1 py-md-4">
          <img
            :src="`/images/icons/${current_content.type}_${imgColor(current_content, current_key)}_icon.svg`"
            width="32px"
            height="32px"
          > 
          <span
            :class="{
              'ml-2': true,
              'text-wrap': true,
              'text-gray-550': current_key != activeTab,
            }"
          >
            {{ current_content.order + 1 }}. {{ current_content.title }}
          </span>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>

import { mapGetters } from "vuex";
import ActiveTabMixin from "./ActiveTabMixin";

export default {
  mixins:[ActiveTabMixin],
  computed: {
    ...mapGetters(['module','contents']),
  },
  methods:{
    onClick(key_value){
      if (this.module.finished_at) {
        this.activeTab = key_value
      }
    },
    imgColor(current_content, current_key){
      if (current_key == this.activeTab) {
        return 'blue'
      }
      if (current_content.finished_at) {
        return 'blue'
      }
      return 'gray'
    },
  }
}
</script>
